
import Vue from "vue"
import { mapActions, mapGetters } from "vuex"
import copyToClipboard from "copy-to-clipboard"
import { getFullName } from "@/utils/name"

export default Vue.extend({
  data: () => ({
    isIdCopied: false,
  }),

  computed: {
    ...mapGetters("user", ["user"]),

    name (): string {
      return getFullName(this.user, this.$fmt.localize)
    },
  },

  methods: {
    ...mapActions("user", { logout: "LOGOUT" }),

    copyToClipboard,

    copyId () {
      this.copyToClipboard(this.user.id)

      this.isIdCopied = true

      setTimeout(() => {
        this.isIdCopied = false
      }, 3000)
    },
  },
})
